module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "upload-facial-photo-wrapper",
    attrs: {
      "element-loading-text": "数据上传中，请不要离开当前页面"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("导入照片\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "upload-bezel"
  }, [_c('el-upload', {
    ref: "uploadRef",
    attrs: {
      "accept": ".zip",
      "limit": 1,
      "action": "#########",
      "http-request": _vm.httpRequest
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "standard-info"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "https://swapp-image.gxapp.iydsj.com/admin-api/facial-standard-tips.png",
      "alt": "人脸照片采集标准要求说明"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                将学生照片按照学号命名，并打包成压缩包，仅支持.ZIP文件上传。\n                "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(ZIP包大小不超过600M)")])]), _vm._v(" "), _c('p', [_vm._v("上传错误时，存在的问题类型：")]), _vm._v(" "), _c('p', [_vm._v("1）学号不存在")]), _vm._v(" "), _c('p', [_vm._v("2）照片尺寸大于300K")]), _vm._v(" "), _c('p', [_vm._v("3）照片尺寸小于100K")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04b01408!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserManage/UserManage/UploadFacialPhoto.vue
// module id = 931
// module chunks = 0